export const ambulanceConst = {
  path: "/single-programs/ambulance",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – СКОРАЯ ПОМОЩЬ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Скорая помощь — когда каждая секунда решает судьбу</h2>
      <p>
        Специальность по неотложной медицине готовит врачей, которые первыми оказываются рядом с пациентом в критической ситуации. Инфаркты,
        инсульты, травмы, острые отравления, внезапные ухудшения состояния — это повседневная практика врача скорой помощи. Работа требует
        не только отличных знаний, но и мгновенной реакции, холодного разума и высокого уровня психологической устойчивости.
      </p>
      <p>
        Эта программа объединяет клиническую медицину, интенсивную терапию, элементы реанимации и навыки работы в чрезвычайных ситуациях.
        Это путь к профессии, где каждый день имеет значение.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Неотложные состояния в кардиологии, неврологии, хирургии</li>
        <li>Реанимация и поддержание жизненных функций</li>
        <li>Медикаментозная терапия в острых случаях</li>
        <li>Действия при ДТП, катастрофах, массовых поражениях</li>
        <li>Интенсивная терапия и транспортировка пациентов</li>
        <li>Коммуникация с пострадавшими и родственниками</li>
        <li>Правовые и этические аспекты оказания экстренной помощи</li>
        <li>Координация с госпитальными и внебольничными службами</li>
      </ul>
      <p>
        Программа предполагает большое количество практических занятий, в том числе симуляционные тренинги, стажировки в отделениях
        неотложной помощи и выезд с бригадами скорой.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач скорой медицинской помощи (в бригаде или стационаре)</li>
        <li>Врач отделения неотложной помощи (приёмное отделение)</li>
        <li>Специалист по медицинским чрезвычайным ситуациям</li>
        <li>Врач-инструктор по первой помощи</li>
        <li>Руководитель подразделения скорой или экстренной помощи</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €110,000 в год,</strong> в зависимости от страны, уровня учреждения и стажа.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Очная и дистанционная формы обучения</li>
        <li>Интенсивная практическая подготовка</li>
        <li>Обучение с опытными врачами скорой и реанимации</li>
        <li>Доступ к тренажерам, симуляторам и клиническим базам</li>
        <li>Программа на английском или русском языке</li>
      </ul>
      <p>
        Скорая помощь — профессия, которой доверяют жизнь. Мы учим действовать точно, быстро и профессионально, даже в самых тяжёлых
        условиях.
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам на каждом этапе: от подачи заявки до выбора индивидуальной траектории обучения.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Скорая помощь — когда каждая секунда решает судьбу
    Специальность по неотложной медицине готовит врачей, которые первыми оказываются рядом с пациентом в критической ситуации. Инфаркты, инсульты, травмы, острые отравления, внезапные ухудшения состояния — это повседневная практика врача скорой помощи. Работа требует не только отличных знаний, но и мгновенной реакции, холодного разума и высокого уровня психологической устойчивости.
    Эта программа объединяет клиническую медицину, интенсивную терапию, элементы реанимации и навыки работы в чрезвычайных ситуациях. Это путь к профессии, где каждый день имеет значение.

    Что вы будете изучать?
    • Неотложные состояния в кардиологии, неврологии, хирургии
    • Реанимация и поддержание жизненных функций
    • Медикаментозная терапия в острых случаях
    • Действия при ДТП, катастрофах, массовых поражениях
    • Интенсивная терапия и транспортировка пациентов
    • Коммуникация с пострадавшими и родственниками
    • Правовые и этические аспекты оказания экстренной помощи
    • Координация с госпитальными и внебольничными службами
    Программа предполагает большое количество практических занятий, в том числе симуляционные тренинги, стажировки в отделениях неотложной помощи и выезд с бригадами скорой.

    Кем можно работать после окончания?
    • Врач скорой медицинской помощи (в бригаде или стационаре)
    • Врач отделения неотложной помощи (приёмное отделение)
    • Специалист по медицинским чрезвычайным ситуациям
    • Врач-инструктор по первой помощи
    • Руководитель подразделения скорой или экстренной помощи

    Средний доход в Европе:
    от €60,000 до €110,000 в год, в зависимости от страны, уровня учреждения и стажа.


    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Очная и дистанционная формы обучения
    • Интенсивная практическая подготовка
    • Обучение с опытными врачами скорой и реанимации
    • Доступ к тренажерам, симуляторам и клиническим базам
    • Программа на английском или русском языке

    Скорая помощь — профессия, которой доверяют жизнь. Мы учим действовать точно, быстро и профессионально, даже в самых тяжёлых условиях.

    Как поступить?
    Приёмная комиссия поможет вам на каждом этапе: от подачи заявки до выбора индивидуальной траектории обучения.
  `,
};
